
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { blockUi, addHeader } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { Scr } from 'src/app/model/scr.model';

import { zip } from 'gzip-js';
import { Base64 } from 'js-base64';
import { CnpjAssociadoAgenteFinanceiroSCR } from 'src/app/model/cnpj-associado-agente-financeiro-scr.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { HttpParams } from '@angular/common/http';
import { TipoIpoc } from './scr-ipoc/ipoc-cadastro.component';

@Injectable({
  providedIn: 'root'
})
export class IntegracaoService extends FgiBackEndService<any> {
  private pesquisar: boolean = false;

  set realizarPesquisa(a: boolean) {
    this.pesquisar = a;
  }

  get realizarPesquisa() {
    return this.pesquisar;
  }
  //
  getAgentesAssociados(): Observable<AgenteFinanceiro[]> | Observable<Array<any>> {
    return this.http.get(`${this.BASE_URL}/agentes`) as Observable<AgenteFinanceiro[]>;
  }

  getOperacoesScrs(id: number, params?: any): Observable<Array<any>>{
    console.log(params.codigoTipoIpoc);
    return this.http.get(`${this.BASE_URL}/operacoes/${id}`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<any>>;
  }

  getScrs(params?: any): any {
    return this.http.get(`${this.BASE_URL}/arquivos`, { params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<Scr>>;
  }

  getScrsAssociados(params: any): Observable<any> | Observable<Array<CnpjAssociadoAgenteFinanceiroSCR>> {
    return this.http.get(`${this.BASE_URL}/associados`, { params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<CnpjAssociadoAgenteFinanceiroSCR>>;
  }

  getAnexo(id: number) {
    return this.http.get(`${this.BASE_URL}/arquivos/${id}/conteudo`, { responseType: 'blob' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  getControle(): Observable<any> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/controle`, options) as Observable<any>;
  }

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/integracoes/scr';
  }

  public async zipEncode(conteudo: string): Promise<string> {
    return Base64.fromUint8Array(new Uint8Array(zip(conteudo)));
  }

  public scrImportacao(referencia: string, file: File, conteudoBase64Zip: string | undefined = undefined): Observable<Scr> {
    const options: any = blockUi();
    addHeader(options, 'Content-Type', 'application/xml');
    addHeader(options, 'Content-Encoding', 'gzip+base64');


    return this.http.post(`${this.BASE_URL}/importacao/${referencia}/${file.name}`, conteudoBase64Zip, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Scr>;
  }


  public cadastrarScrAssociado(associadoDto : CnpjAssociadoAgenteFinanceiroSCR): Observable<CnpjAssociadoAgenteFinanceiroSCR>{
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/associados/cadastrar`, associadoDto, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<CnpjAssociadoAgenteFinanceiroSCR>;
  }

  public excluirScrAssociado(idAssociado: number): Observable<CnpjAssociadoAgenteFinanceiroSCR>{
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/associados/excluir/${idAssociado}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<CnpjAssociadoAgenteFinanceiroSCR>;
  }

/*  public scrImportacaoAutomatica(): Observable<void> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/importacao`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<void>;
  }

  public scrImportacaoAutomaticaReferenciaEspecifica(referencia: string): Observable<void> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/importacao/${referencia}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<void>;
  }*/

  getAgenteFinanceiroAssociados(cnpj: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.BASE_URL}/${cnpj}/agente-financerio-associados`).pipe(
      catchError((e) => this.handleError(e))) as Observable<string[]>;
  }


  getAgenteFinanceiroPossuiAssociados(cnpj: string): Observable<boolean> {
    let params = new HttpParams().set("cnpj", cnpj);
    return this.http.get(`${this.BASE_URL}/agentes/agente-financerio-possui-associados`, {params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<boolean>;
  }
}
